<template>
  <div id="app">
    <ToastNotification ref="toastComponent" />
    <router-view />
  </div>
</template>

<script>
import ToastNotification from "./components/Common/ToastNotification.vue";
import emitter from "./eventBus";

export default {
  name: "App",
  components: {
    ToastNotification,
  },
  mounted() {
    emitter.on("show-toast", ({ message, type = "danger" }) => {
      this.$refs.toastComponent.showToast(message, type);
    });
  },
};
</script>
